"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var utils_1 = require("./utils");
var spacing_1 = require("../spacing");
var grid_1 = require("../grid");
var __1 = require("../..");
var HoverContainer = (0, styled_components_1.default)(grid_1.Container)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex-wrap: nowrap;\n  cursor: pointer;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  * {\n    &:hover {\n      cursor: pointer;\n    }\n  }\n"], ["\n  flex-wrap: nowrap;\n  cursor: pointer;\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  * {\n    &:hover {\n      cursor: pointer;\n    }\n  }\n"])));
var CheckboxStyle = (0, styled_components_1.default)(spacing_1.Div)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n  height: 20px;\n  width: 20px;\n  cursor: pointer;\n\n  input[type='checkbox'] {\n    ", "\n    cursor: pointer;\n    appearance: none;\n    height: 20px;\n    width: 20px;\n\n    &:checked {\n      background-color: ", ";\n      border-color: ", ";\n    }\n  }\n\n  svg {\n    position: absolute;\n    top: 6px;\n    left: 4px;\n  }\n"], ["\n  position: relative;\n  height: 20px;\n  width: 20px;\n  cursor: pointer;\n\n  input[type='checkbox'] {\n    ", "\n    cursor: pointer;\n    appearance: none;\n    height: 20px;\n    width: 20px;\n\n    &:checked {\n      background-color: ", ";\n      border-color: ", ";\n    }\n  }\n\n  svg {\n    position: absolute;\n    top: 6px;\n    left: 4px;\n  }\n"])), utils_1.inputStyle, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
});
exports.Checkbox = react_1.default.forwardRef(function (_a, forwardedRef) {
    var _b, _c;
    var _d = _a.styledProps, styledProps = _d === void 0 ? {} : _d, _e = _a.containerProps, containerProps = _e === void 0 ? {} : _e, children = _a.children, nativeProps = __rest(_a, ["styledProps", "containerProps", "children"]);
    var defaultChecked = nativeProps.defaultChecked, onChange = nativeProps.onChange, ref = nativeProps.ref, rest = __rest(nativeProps, ["defaultChecked", "onChange", "ref"]);
    var _f = (0, react_1.useState)((_c = (_b = nativeProps.checked) !== null && _b !== void 0 ? _b : defaultChecked) !== null && _c !== void 0 ? _c : false), checked = _f[0], setChecked = _f[1];
    var checkbox = (0, react_1.useRef)(null);
    var input = (react_1.default.createElement(CheckboxStyle, __assign({}, styledProps),
        checked ? (react_1.default.createElement("svg", { width: "12", height: "9", fill: "none", xmlns: "http://www.w3.org/2000/svg", onClick: function (e) {
                !rest.readOnly && checkbox.current.click();
                e.stopPropagation();
            } },
            react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.73 8.037L.15 4.542a.484.484 0 010-.7l.723-.698a.525.525 0 01.723 0L4.09 5.59 9.654.144a.525.525 0 01.723 0l.723.7c.2.192.2.506 0 .697L4.452 8.037a.525.525 0 01-.723 0z", fill: "#fff" }))) : null,
        react_1.default.createElement("input", __assign({}, rest, { ref: (0, __1.mergeRefs)(checkbox, ref, forwardedRef), defaultChecked: checked, onClick: function (e) {
                e.stopPropagation();
                if (rest.readOnly) {
                    e.preventDefault();
                }
            }, onChange: function (e) {
                if (rest.readOnly) {
                    return;
                }
                setChecked(e.target.checked);
                onChange && onChange(e);
            }, type: "checkbox" }))));
    if (children) {
        return (react_1.default.createElement(HoverContainer, __assign({ align: "center", onClick: function () { return !rest.readOnly && checkbox.current.click(); }, grow: true }, containerProps),
            react_1.default.createElement(spacing_1.Div, { pr: 1 }, input),
            children));
    }
    return input;
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=Checkbox.js.map